import { all } from "redux-saga/effects";
import { default as advSagas } from "./components/advertising/logic/adSagas";
import { default as advFormSagas } from "./components/advertising/logic/formSagas";
import { default as appSagas } from "./components/global/logic/sagas";
import { default as loginSagas } from "./components/login/logic/sagas";
import { default as settingsSagas } from "./components/settings/tags/logic/sagas";
import { default as templateSagas } from "./components/settings/templates/logic/sagas";
import { default as advForstatisticsSagas } from "./components/statistics/logic/sagas";

import log from "loglevel";
import { default as contactSagas } from "./components/contact/logic/contactSagas";
import { default as filesSagas } from "./components/fileViewers/logic/sagas";
import { default as filmReleaseFormSagas } from "./components/film/logic/filmFormSagas";
import { default as filmReleaseListSagas } from "./components/film/logic/filmListSagas";
import { default as relatedFilmsFormSagas } from "./components/relatedFilms/logic/relatedFilmsFormSagas";
import { default as reportAdvSagas } from "./components/report/advertising/logic/advReportSagas";
import { default as reportLogSagas } from "./components/report/logsheet/logic/logReportSagas";
import { default as reviewSagas } from "./components/review/logic/sagas";
import { default as apiImportSagas } from "./components/settings/apiImport/logic/sagas";
import { default as userFormSagas } from "./components/settings/user/form/logic/sagas";
import { default as userListSagas } from "./components/settings/user/list/logic/sagas";

export default function* rootSaga() {
    try {
        yield all([
            ...appSagas,
            ...loginSagas,
            ...advFormSagas,
            ...advForstatisticsSagas,
            ...settingsSagas,
            ...reviewSagas,
            ...filmReleaseFormSagas,
            ...filmReleaseListSagas,
            ...reportAdvSagas,
            ...reportLogSagas,
            ...relatedFilmsFormSagas,
            ...contactSagas,
            ...apiImportSagas,
            ...templateSagas,
            ...userListSagas,
            ...userFormSagas,
            ...filesSagas,
            ...advSagas,
        ]);
    } catch (error) {
        log.error(error);
    }
}
